<template>
  <div class="group-featured-feed" style="margin:15px 0 10px" v-if="false && orderList && orderList.careplan_item > 0">
    <swiper :options="swiperOption" class="presentation">
      <swiper-slide v-for="(i,k) in orderList" v-if="orderList.careplan_item.length > 0" :key="k">
        <div class="demo-carousel">
          <router-link tag="div" :to="'/feed/' + i.id" class="ms-carousel-item-div">
            <Card shadow :padding="0" class="ms-carousel-item-div-card" style="position:relative;border:1px solid #ddd">
              <div class="card-holder">
                <div class="feed-details">
                  <small><b style="display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;overflow: hidden;">{{i.title}}</b></small>
                  <div v-show="i.activity_count" class="feed-actions" style="position: absolute;bottom: 5px;font-size:77% !important;">
                    <router-link style="font-size: 80%;color:rgb(170, 170, 170);" tag="span" :to="'/feed/' + i.id"><i class="far fa-comment"></i>&nbsp;
                      Comments {{ (i.activity_count > 0) ? i.activity_count : ''}}</router-link>
                  </div>
                </div>
                <div class="image" :style="{background: 'url('+ postPreviewImage(i) +')'}" v-if="i.cover_photo">
                  <span class="feed-icons">
                    <Avatar v-if="i.type == 'attachment' && i.data.attachment_type == 'video'" icon="play" class="feed-icon"></Avatar>
                    <!-- <Avatar v-if="i.type == 'trivia' && i.data.mode == 'poll'" icon="pie-graph" class="feed-icon"></Avatar> -->
                    <Avatar v-if="i.type == 'trivia' && i.data.mode == 'poll'" :src="barIcon" class="feed-icon"></Avatar>
                    <!-- <Avatar v-if="i.type == 'attachment' && i.data.attachment_type == 'slideshow'" icon="images" class="feed-icon"></Avatar> -->
                    <Avatar v-if="i.type == 'attachment' && i.data.attachment_type == 'link'" icon="link" class="feed-icon"></Avatar>
                  </span>
                </div>
              </div>
            </Card>
          </router-link>
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination" slot="pagination" style="position:initial !important;" ></div>
  </div>
</template>

<script>
import Utils from '@/utils.js'
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
  components: { swiper, swiperSlide },
  props: {
    ltype: {
      type: String,
    }
  },
  data() {
    return {
      swiperOption: {
          slidesPerView: 1,
          spaceBetween: 30,
          keyboard: {
            enabled: true,
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
    }
  },
  methods: {
    postPreviewImage (act) {
      return Utils.getDisplayImage('activity', act, 'medium')
    },
  },
  computed: {
    orderList: {
      get() {
        if( this.ltype === 'extra' )
          return this.featureExtraActivity.careplan_item
        if( this.ltype === 'discover' )
          return this.featureDiscoverActivity.careplan_item
        return []
      }
    },
    featureExtraActivity: {
      get () { return this.$store.state.feature.extra }
    },
    featureDiscoverActivity: {
      get () { return this.$store.state.feature.discover }
    }
  }
}
</script>

<style>
  .group-featured-feed .swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets > span {
    margin-right: 5px !important;
  }
</style>

<style scoped>
  .demo-carousel {
    width: auto;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
  }
  .card-holder {
    width: 100%;
    height: 130px;
    background: #fff;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: space-between;
  }
  .card-holder > .feed-details,.card-holder > .image{
    /* flex-grow: 1;
    flex-basis: 0; */
    height: 100%;
  }

  .card-holder > .feed-details{
    display: flex;
    flex-direction: column;
    width: 66%;
    padding: 10px;
  }

  .card-holder > .image{
    background-repeat: no-repeat !important;
    background-position: center !important;
    -webkit-background-size: cover !important;
    -moz-background-size: cover !important;
    -o-background-size: cover !important;
    background-size: cover !important;
    width:160px;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
  }
  .ms-carousel-item-div-card {
    position:relative;
    height:130px;
    overflow:hidden;
  }
  .demo-carousel {
    width: auto;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
  }
  .ms-carousel-item-div {
    width:92vw;
    display:inline-block;
  }
  .ms-carousel-item-div-card {
    position:relative;
    height:130px;
    overflow:hidden;
  }
  .ms-item-titlebar {
    position:absolute;
    top:0;
    left:0;
    color:white;
    padding:5px;
    width:100%;
    background: rgba(0,0,0,.3);
    text-align:left;
    z-index:1;
  }
  .ms-item-image-container {
    width:100%;
    background:#ddd;
    border-bottom:1px solid #ddd;
    overflow:hidden;
    height:215px;
  }
</style>
